import { useQuery, UseQueryOptions } from 'react-query';
import { UsersService } from '../../services';
import { IDetailedUser } from '../../interfaces';

export const useGetUserById = (id: string | number | undefined, options?: UseQueryOptions<IDetailedUser, Error>) => {
  return useQuery<IDetailedUser, Error>(
    ['users', id],
    async () => {
      const result = await UsersService.getUserById(id!);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { enabled: !!id, cacheTime: 0, ...options },
  );
};
